import { BulkScrubRequest, ClaimControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  bulkScrubRequest: BulkScrubRequest;
  xTENANTID?: string;
}

export const useBulkScrubClaims = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimControllerApi(getConfigObject()).bulkScrubClaims(
      params.bulkScrubRequest,
      params.xTENANTID
    )
  );
